export default "__VITE_ASSET__DLoLvBL$__"